import React from 'react'
import { Tooltip } from '@material-ui/core'
import { useNavigate } from 'react-router-dom'
import ResultButton from './ResultButton'

const GoToMethylationDashboard = ({ analysisWrapperId }) => {
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(`/libra/methylation/${analysisWrapperId}`)
  }

  return (
    <Tooltip title="Open methylation dashboard" arrow>
      <ResultButton onClick={handleClick}>Methylation</ResultButton>
    </Tooltip>
  )
}

export default GoToMethylationDashboard
